import { useEffect } from '@wordpress/element';
import classNames from 'classnames';
import qs from 'query-string';
import { Link } from 'react-router-dom';
import { getTranslation } from '../../../languages';
import './styles.scss';

const createPageArray = (from, to, currentLocation) => {
    const arr = [];
    const query = qs.parse(currentLocation);
    
    for (var i = from; i <= to; i++) {
        query.page = i;
        arr.push({
            url: `?${qs.stringify(query)}`,
            number: i
        });
    }

    return arr;
}

const Paginate = ({ totalCount, queryPage, location, typeOfList, perPage, useLink = false }) => {
    
    const query = qs.parse(location.search);
    const currentPage = isNaN(parseInt(queryPage)) ? 1 : parseInt(queryPage);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);
    
    const totalPages = Math.ceil(totalCount / perPage);
    let pages = [];

    if (totalPages > 7) {
        queryPage = 1
        pages = [{ url: `?${qs.stringify({
            ...query,
            page: 1
        })}`, number: 1 }, { number: '...'}, ...createPageArray(currentPage-1, currentPage+1, location.search), { number: '...'}, { url: `?${qs.stringify({
            ...query,
            page: totalPages
        })}`, number: totalPages }];    

        if (currentPage < 5) {
            query.page = totalPages;
            pages = [...createPageArray(1, 5, location.search), { number: '...'}, { url: `?${qs.stringify(query)}`, number: totalPages }];            
        }

        if (currentPage > totalPages-4) {
            query.page = 1
            pages = [{ url: `?${qs.stringify(query)}`, number: 1 }, { number: '...'}, ...createPageArray(totalPages-4, totalPages, location.search)];            
        }
    } else {
        pages = [...createPageArray(1, totalPages, location.search)];
    }

    let ofTotalSearchText = totalCount;
    if (totalCount > 1000) {
        ofTotalSearchText = `över ${Math.floor(totalCount / 1000) * 1000}`; 
    }
    
    query.page = currentPage-1;
    const prevLink = qs.stringify(query);
    query.page = currentPage+1;
    const nextLink = qs.stringify(query);

    return (
        <div className="paginate">
            {totalPages > 1  &&
                <ul className="paginate__pages">
                    {currentPage !== 1 &&
                        <li>
                            {useLink &&
                                <Link className="paginate__nav paginate__nav--prev" to={`?${prevLink}`}></Link>
                            }
                            {!useLink &&
                                <a className="paginate__nav paginate__nav--prev" href={`?${prevLink}`}></a>
                            }
                            
                        </li>
                    }

                    {pages.map((page, i) => {
                        return (
                            <li key={`page${i}`}>
                                {page.url && (useLink ? 
                                    <Link className={classNames({
                                        'paginate__page': true,
                                        'paginate__page--is-selected': page.number === currentPage,
                                    })} to={page.url}>{page.number}</Link> : 
                                    <a className={classNames({
                                        'paginate__page': true,
                                        'paginate__page--is-selected': page.number === currentPage,
                                    })} href={page.url}>{page.number}</a>)
                                }
                                {!page.url &&
                                    <>
                                        {page.number}
                                    </>
                                }
                            </li>
                        );
                    })}

                    {currentPage !== totalPages &&
                        <li>
                            {useLink &&
                                <Link className="paginate__nav paginate__nav--next" to={`?${nextLink}`}></Link>
                            }
                            {!useLink &&
                                <a className="paginate__nav paginate__nav--next" href={`?${nextLink}`}></a>
                            }   
                            
                        </li>
                    }
                </ul>
            }
            <p className="paginate__text">{getTranslation('Visar', 'dalslandskanal-custom-blocks/pagination')} {((currentPage-1)*20) + 1} - {currentPage*20 > totalCount ? totalCount : currentPage*20} {getTranslation('av', 'dalslandskanal-custom-blocks/pagination')} {ofTotalSearchText} {typeOfList}</p>
        </div>   
    );
};

export default Paginate;